var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8881 8C16.8881 12.1061 13.2773 15.5 8.73947 15.5C4.20167 15.5 0.59082 12.1061 0.59082 8C0.59082 3.89385 4.20167 0.5 8.73947 0.5C13.2773 0.5 16.8881 3.89385 16.8881 8Z",
    fill: "#743BBC",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2198 5.74064C12.3171 5.83065 12.3718 5.95272 12.3718 6.08C12.3718 6.20727 12.3171 6.32934 12.2198 6.41936L8.0685 10.2594C7.97119 10.3493 7.83922 10.3999 7.70162 10.3999C7.56402 10.3999 7.43206 10.3493 7.33475 10.2594L5.25907 8.33936C5.16454 8.24883 5.11224 8.12758 5.11342 8.00172C5.11461 7.87587 5.16918 7.75548 5.26539 7.66648C5.3616 7.57749 5.49175 7.52701 5.62781 7.52591C5.76387 7.52482 5.89495 7.5732 5.99282 7.66064L7.70162 9.24128L11.4861 5.74064C11.5834 5.65065 11.7154 5.6001 11.853 5.6001C11.9906 5.6001 12.1225 5.65065 12.2198 5.74064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRound);
export default __webpack_public_path__ + "static/media/checked-round.aaa5686fd2cab53bb017749fcce59b3f.svg";
export { ForwardRef as ReactComponent };